(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  
  // Inicializar el administrador cuando el DOM esté listo
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded');
    class GiftWrapManager {
    constructor() {
      this.checkbox = document.querySelector('.cart-gift-checkbox');
      this.textarea = document.querySelector('textarea[name="attributes[gift-note]"]');
      this.submitButton = document.querySelector('button[type="submit"]');
      this.timeout = null;
  
      this.init();
    }
  
    init() {
      this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      this.textarea.addEventListener('input', this.handleTextareaInput.bind(this));
    }
  
    async handleCheckboxChange(event) {
      this.checkbox.disabled = true;
  
      try {
        if (event.target.checked) {
          await this.addGiftWrap();
        } else {
          await this.removeGiftWrap();
        }
      } catch (error) {
        console.error('Error:', error);
        // Revertir el estado del checkbox en caso de error
        event.target.checked = !event.target.checked;
      } finally {
        this.checkbox.disabled = false;
        window.location.reload();
      }
    }
  
    async addGiftWrap() {
      const formData = {
        items: [{
          id: 42830624030960,
          quantity: 1
        }]
      };
  
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
    }
  
    async removeGiftWrap() {
      const formData = {
        updates: {
          42830624030960: 0
        }
      };
  
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
    }
  
    handleTextareaInput(event) {
      clearTimeout(this.timeout);
  
      this.timeout = setTimeout(async () => {
        this.submitButton.disabled = true;
  
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                'gift-note': event.target.value
              }
            })
          });
        } catch (error) {
          console.error('Error:', error);
        } finally {
          this.submitButton.disabled = false;
        }
      }, 1000);
    }
  }
    new GiftWrapManager();
  });  

  } catch(e) { console.error(e); }
})();
})();
